import {Trans} from '@lingui/macro';
import React, {FC} from 'react';
import {connect} from 'react-redux';

import {LegacySidePanelEntryPoint} from '../../../../../helpers/models/legacyApplicationHelpers';
import {makeMapStateToProps} from '../../../../../helpers/reselectHelpers';
import {LegacyApplicationModel} from '../../../../../models/api/legacyApplicationModel';
import {makeGetLegacyApplicationFromEntryPoint} from '../../../../../store/data/applications/legacyApplicationsSelectors';
import {FrameCard, FrameCardProps} from './frameCard';
import {FrameCardCategory} from './frameCardCategory';
import {FrameCardName} from './frameCardName';
import {FrameCardPin, FrameCardPinProps} from './frameCardPin';
import {IntegrationFrameCardAvatar} from './integrationFrameCardAvatar';
import {IntegrationFrameCardCategory} from './integrationFrameCardCategory';
import {PluginFrameCardAvatar} from './pluginFrameCardAvatar';

/*
 * Props.
 */

interface EntryPointFrameCardProps extends FrameCardProps, FrameCardPinProps {
  entryPoint: LegacySidePanelEntryPoint;
}

interface EntryPointFrameCardComponentProps extends EntryPointFrameCardProps {
  entryPoint: LegacySidePanelEntryPoint;
  application: LegacyApplicationModel;
}

/*
 * Component.
 */

const EntryPointFrameCardComponent: FC<EntryPointFrameCardComponentProps> = ({
  entryPoint,
  application,
  ...props
}) => (
  <FrameCard {...props} isEnabled>
    {renderAvatar(entryPoint)}
    <FrameCardName>{entryPoint.name}</FrameCardName>
    {renderCategory(application)}
    <FrameCardPin {...props} />
  </FrameCard>
);

function renderAvatar(entryPoint: LegacySidePanelEntryPoint) {
  const {iconBaseUrl} = entryPoint;

  if (iconBaseUrl) {
    return <IntegrationFrameCardAvatar integrationIconsUrl={iconBaseUrl} />;
  }

  return <PluginFrameCardAvatar pluginName={entryPoint.name} pluginColor={entryPoint.color} />;
}

function renderCategory(application: LegacyApplicationModel) {
  const category = application.categories && application.categories[0];

  if (category) {
    return <IntegrationFrameCardCategory category={category} />;
  }

  return (
    <FrameCardCategory>
      <Trans id="sidepanel-plugin">Plugin</Trans>
    </FrameCardCategory>
  );
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<EntryPointFrameCardProps>()(() => ({
  application: makeGetLegacyApplicationFromEntryPoint((_state, props) => props.entryPoint),
}));

export const EntryPointFrameCard = connect(mapStateToProps)(EntryPointFrameCardComponent);
